<template>
  <div class="create-bookmark modal" role="alert">
    <div class="create-bookmark__wrapper modal__wrapper">
      <button class="create-bookmark__close" @click="closeModal()">
        <XIcon class="create-bookmark__close--icon" />
      </button>
      <div class="create-bookmark__header">
        <h6 class="create-bookmark__title">Create Bookmark</h6>
        <div class="create-bookmark__info">
          <h6 class="create-bookmark__video-title">
            {{ pendingBookmark.title }}
          </h6>
        </div>
      </div>
      <div class="create-bookmark__time">
        <input
          v-model="time"
          class="ine-input create-bookmark__time-input"
          disabled
        />
      </div>
      <div
        class="create-bookmark__form-group create-bookmark__video-description-entry"
      >
        <textarea
          v-model="description"
          placeholder="Enter Notes for This Bookmark"
          class="ine-input"
          :class="
            invalidDescription
              ? 'create-bookmark__error-in-form create-bookmark__form-control'
              : 'create-bookmark__form-control'
          "
          rows="4"
          @focus="invalidDescription = false"
        ></textarea>
        <small
          v-show="invalidDescription"
          class="create-bookmark__invalid-warning"
          >* Notes are required</small
        >
      </div>
      <div class="create-bookmark__button-group">
        <button
          v-if="!isLoading"
          class="btn btn--primary create-bookmark__confirm-btn"
          @click="createBookmark()"
        >
          Save bookmark
        </button>
        <button
          v-if="!isLoading"
          class="btn btn--tertiary"
          @click="closeModal()"
        >
          Cancel
        </button>
        <div v-if="isLoading" class="create-bookmark__loading-wrapper">
          <LoadingSmallSpinner />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSmallSpinner from '@/components/loaders/LoadingSmallSpinner.vue'
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'CreateBookmark',
  components: {
    LoadingSmallSpinner,
    XIcon,
  },
  props: {
    pendingBookmark: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      description: '',
      isLoading: false,
      invalidDescription: false,
      time: 0,
    }
  },
  created() {
    this.time = this.$duration.hhmmss(this.pendingBookmark.time)
    const body = document.querySelector('body')
    body.classList.add('modal-open')
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
  methods: {
    async createBookmark() {
      this.isLoading = true
      if (this.description === '') {
        this.invalidDescription = true
        this.isLoading = false
        return
      }
      const bookmark = {
        notes: this.description,
        time: this.time === 0 ? 0 : this.$duration.convertToSeconds(this.time),
        videoId: this.pendingBookmark.videoId,
        courseId: this.pendingBookmark.courseId,
      }
      if (!this.invalidDescription) {
        await this.$store.dispatch('content/addBookmark', bookmark)
        await this.$store.dispatch('content/getBookmarks')
        this.$store.dispatch('app/setSuccess', `Your Bookmark has been saved`)
        this.closeModal()
      } else {
        this.isLoading = false
      }
    },
    closeModal() {
      this.$emit('resume-video')
      this.$emit('closed', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.create-bookmark {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: var(--black-90);
  transition: opacity 0.3s ease;
  overflow: auto;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    top: 15%;
    margin: 0px auto;
    padding: 90px 0 30px 0;
    background: linear-gradient(104.99deg, #2c2c32, #121213);
    border-radius: 24px;
    color: var(--white);
    max-width: 780px;
  }
  &__title {
    text-align: center;
    margin: 0 auto;
    font-size: rem(40px);
    line-height: 52px;
    font-weight: bold;
    font-family: var(--font-bold);
  }
  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px;
  }
  &__video-title {
    color: var(--light-blue-gray);
    margin: 0;
    width: 100%;
    text-align: center;
  }
  &__lead {
    color: var(--gray);
  }
  &__time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @include tablet {
      width: 500px;
    }
    &-input {
      width: 100%;
      text-align: left;
    }
  }
  &__time-lead {
    font-size: 1.25rem;
    margin-right: 10px;
    color: var(--gray);
  }
  &__error-in-form {
    border: 1px solid var(--red);
  }
  &__invalid-time {
    color: var(--red);
    position: absolute;
    margin: 30px 0 0 55px;
  }
  &__video-description-entry {
    width: 100%;
    margin-top: 30px;
    @include tablet {
      width: 500px;
    }
    textarea {
      width: 100%;
    }
  }
  &__invalid-warning {
    height: 10px;
    color: var(--red);
  }
  &__button-group {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
    align-items: center;
  }
  &__confirm-btn {
    margin-bottom: 20px;
  }
  &__success-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }
  &__success-positioning {
    display: table-cell;
    vertical-align: middle;
    position: relative;
    margin: 0 auto;
  }
  &__success-wrapper {
    background-color: var(--light-gray);
    padding: 0 50px 20px 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    @include mobile {
      width: 30%;
    }
  }
  &__success {
    color: var(--white);
    font-size: 2rem;
    padding: 50px 50px 20px 50px;
    margin: 0 auto;
    text-align: center;
  }
  &__close {
    position: absolute;
    right: 34px;
    top: 34px;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 0;
    padding: 0;
    &:hover {
      .upgrade__close--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      stroke: var(--white);
    }
  }
}
</style>
